"use client";

import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export type StrongTitleProps = {
	title: string;
	highlightText: string;
	titleClassName?: string;
	highlightClassName?: string;
};

export const StrongTitle = ({
	title,
	highlightText,
	titleClassName,
	highlightClassName,
}: StrongTitleProps) => {
	return (
		<motion.h1
			className={cn(
				"font-semibold text-black text-xl sm:text-2xl md:text-3xl",
				titleClassName,
			)}
			initial={{ opacity: 0, y: 20 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
		>
			{title} <br />
			<motion.span
				className={cn(
					"mt-1 font-bold text-3xl leading-none sm:text-4xl md:text-5xl",
					highlightClassName,
				)}
				initial={{ opacity: 0, y: 20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.6, delay: 0.2 }}
			>
				{highlightText}
			</motion.span>
		</motion.h1>
	);
};
